module.exports = __webpack_public_path__ + "analytics.svg?78231d115d06ae90d4f948439dc12dd1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/analytics.svg
// module id = 43
// module chunks = 0